<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { theme, ThemeModes } from '@shared/ui/theme';
  import { cn } from '@shared/utils';

  import SwitchStep from './switch-item.svelte';

  export let isFirstStep = false;

  export let firstStepName = 'Approval Request';
  export let secondStepName = 'Bid Submission';
  export let firstStepClasses = '';
  export let secondStepClasses = '';
</script>

<div class="bg-grey dark:bg-store-dark relative flex flex-row overflow-hidden">
  <div
    class="{cn(
      'bg-default-50 text-default-500 border-default-250 dark:border-dark-400 dark:bg-store-dark dark:text-dark-600 relative flex w-full items-center justify-between gap-3 rounded-lg rounded-r-none border border-r-0 p-3 md:w-1/2',
      {
        'bg-default-50 text-default-900 dark:text-default-50': isFirstStep,
        'w-min pr-0': !isFirstStep,
      },
      firstStepClasses,
    )}"
  >
    <div
      class="{cn('flex items-center gap-3', {
        'gap-0 md:gap-3': !isFirstStep,
      })}"
    >
      <SwitchStep
        isActive="{isFirstStep}"
        classes="{cn({
          'bg-default-50 border-default-300 border dark:bg-store-dark dark:border-dark-500': !isFirstStep,
        })}"
      >
        <svelte:fragment slot="step">
          {#if isFirstStep}
            1
          {:else}
            <Icon name="checkMark" classes="text-emerald-600" />
          {/if}
        </svelte:fragment>

        <svelte:fragment slot="text">
          <span
            class="{cn('text-default-900 dark:text-default-50', {
              'hidden md:block': !isFirstStep,
            })}"
          >
            {firstStepName}
          </span>
        </svelte:fragment>
      </SwitchStep>
    </div>

    <Icon
      name="arrow-fill"
      classes="{cn(
        'h-full w-auto absolute bottom-0 right-[1px] top-0 text-default-320 text-default-250 dark:text-dark-400 hidden translate-x-full md:block',
        {
          'fill-store-dark': $theme === ThemeModes.Dark,
        },
      )}"
    />
  </div>

  <div
    class="{cn(
      'text-default-500 dark:bg-store-dark dark:border-dark-400 flex items-center gap-3 rounded-lg rounded-l-none border border-l-0 p-3 md:w-1/2 md:px-10 md:py-3',
      {
        'bg-default-50 border-default-250 text-default-900 dark:text-default-50 w-full': !isFirstStep,
      },
      secondStepClasses,
    )}"
  >
    <SwitchStep isActive="{!isFirstStep}">
      <svelte:fragment slot="step">2</svelte:fragment>
      <svelte:fragment slot="text">
        <span
          class="{cn({
            'hidden md:block': isFirstStep,
          })}"
        >
          {secondStepName}
        </span>
      </svelte:fragment>
    </SwitchStep>
  </div>

  <div class="bg-default-200 dark:bg-dark-400 absolute bottom-0 left-0 right-0 h-[3px] md:hidden"></div>
  <div
    class="{cn(
      'absolute bottom-0 left-0 right-0 h-[3px] -translate-x-1/2 bg-emerald-600 transition-transform duration-500 ease-in-out md:hidden',
      {
        'translate-x-0': !isFirstStep,
      },
    )}"
  ></div>
</div>
